import React, { useEffect, useState } from 'react';

export type VistaActiva = 'kanban' | 'tabla' | 'calendario' | 'timeline';

const VISTA_KEY = 'minotion.vista.activa';

const VISTAS: Array<{ key: VistaActiva; label: string; icon: string; hint: string }> = [
    { key: 'kanban',     label: 'Tablero',   icon: '▦', hint: 'Kanban swimlanes' },
    { key: 'tabla',      label: 'Tabla',     icon: '☰', hint: 'Lista de tareas' },
    { key: 'calendario', label: 'Calendario',icon: '📅', hint: 'Por fecha límite' },
    { key: 'timeline',   label: 'Timeline',  icon: '▭', hint: 'Creado → Deadline' },
];

export const loadVistaActiva = (): VistaActiva => {
    if (typeof window === 'undefined') return 'kanban';
    try {
        const stored = window.localStorage.getItem(VISTA_KEY);
        if (stored && VISTAS.some(v => v.key === stored)) return stored as VistaActiva;
    } catch {}
    return 'kanban';
};

interface SelectorVistaProps {
    activa: VistaActiva;
    onChange: (vista: VistaActiva) => void;
}

export const SelectorVista: React.FC<SelectorVistaProps> = ({ activa, onChange }) => {
    // `max-w-full` + `overflow-x-auto` (en vez de `inline-flex` sin tope): en
    // mobile este control con 4 opciones no entra en 360px — que scrollee
    // horizontal dentro de sí mismo, no que desborde la página.
    return (
        <div className="flex items-center gap-1 p-1 bg-slate-100 rounded-lg border border-slate-200 max-w-full overflow-x-auto scrollbar-thin">
            <span className="text-[11px] font-semibold uppercase tracking-wider text-slate-500 px-2 flex-shrink-0">
                Vista
            </span>
            {VISTAS.map(v => {
                const isActive = activa === v.key;
                return (
                    <button
                        key={v.key}
                        onClick={() => onChange(v.key)}
                        title={v.hint}
                        className={`flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-md transition-all flex-shrink-0 ${
                            isActive
                                ? 'bg-white text-slate-900 shadow-sm border border-slate-200'
                                : 'text-slate-600 hover:text-slate-900 hover:bg-white/60'
                        }`}
                    >
                        <span aria-hidden>{v.icon}</span>
                        <span>{v.label}</span>
                    </button>
                );
            })}
        </div>
    );
};

export const useVistaActiva = (): [VistaActiva, (v: VistaActiva) => void] => {
    const [vista, setVista] = useState<VistaActiva>(loadVistaActiva);

    useEffect(() => {
        try {
            window.localStorage.setItem(VISTA_KEY, vista);
        } catch {}
    }, [vista]);

    return [vista, setVista];
};